import { TailSpin } from "react-loader-spinner";
import { useSelector } from "react-redux";
import { StyledMainBox } from "./StyledComponents/styled";
import { Backdrop, Box, CircularProgress } from "@mui/material";
import { TextButton, WhiteTextButton } from "./Buttons/ActionButton";
import { Cancel } from "@mui/icons-material";
import { cancelOngoingRequests } from "../../api_calls/requestConfig";

const Loader = () => {
  const appState = useSelector((state) => state.userSelections);
  const handleCancel = () => {
    cancelOngoingRequests();
  };
  return (
    <>
      {
        (typeof appState.loading !== "undefined" && appState.loading === true) ||
          (typeof appState.batchLoading !== "undefined" && appState.batchLoading === true) ||
          (typeof appState.filtersBatchLoading !== "undefined" && appState.filtersBatchLoading === true) ||
          (typeof appState.overlayLoading !== "undefined" && appState.overlayLoading === true) ? (
          <StyledMainBox component="main">
            {/* ---------- loader code -------- */}
            <Backdrop sx={{ color: "#fff", zIndex: "9999" }} open={appState.loading || appState.batchLoading || appState.filtersBatchLoading || appState.overlayLoading}>
              <Box
                display="flex"
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
              >
                <CircularProgress
                  variant="indeterminate"
                  disableShrink
                  sx={(theme) => ({
                    color: "#fff",
                    animationDuration: "750ms",
                  })}
                />
                {/* ✅ Cancel Button: to cancel any ongoing request that takes longer to complete */}
                {
                  typeof appState.show_loading_cancel_button !== "unndefined" && appState.show_loading_cancel_button === true && (
                    <WhiteTextButton
                      label={"Cancel"}
                      icon={<Cancel />}
                      sx={{ mt: 2 }}
                      onClick={handleCancel}
                    />
                  )
                }
              </Box>

            </Backdrop>
            {/* <TailSpin
            height="80"
            width="80"
            color="#2D2D37"
            ariaLabel="tail-spin-loading"
            radius="1"
            wrapperStyle={{
              position: "fixed",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
            }}
            wrapperClass=""
            visible={true}
          /> */}
          </StyledMainBox>
        ) : (
          <></>
        )}
    </>
  );
};

export default Loader;
